// extracted by mini-css-extract-plugin
module.exports = {"host":"KiosksToolbar_host__39iLd","label":"KiosksToolbar_label__2qzJx","button":"KiosksToolbar_button__32qy5"};